import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-food-collection',
  templateUrl: './food-collection.component.html',
  styleUrls: ['./food-collection.component.scss']
})
export class FoodCollectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
